// extracted by mini-css-extract-plugin
export default {"listBlock":"qBLA6","title":"pXe3A","list":"BOd4U","listItem":"N_Upa","marker":"fhcUk","nuance":"urTud"};